import React, { useEffect } from 'react'

const UG_EMBED_SRC = 'https://static.userguiding.com/media/user-guiding-YOJ104543AKXID-embedded.js'
const CHATBASE_EMBED_ID = 'DHiQ4GHGKxF9-msTzrqJl'

const SupportScripts = () => {
  useEffect(() => {
    const existingUgScript = document.querySelector(`script[src="${UG_EMBED_SRC}"]`)
    const existingUgStub = document.querySelector('script[data-ug-stub="true"]')
    if (!existingUgScript && !existingUgStub && typeof window !== 'undefined') {
      const ugStub = document.createElement('script')
      ugStub.setAttribute('data-ug-stub', 'true')
      ugStub.text = `(function(g,u,i,d,e,s){g[e]=g[e]||[];var f=u.getElementsByTagName(i)[0];var k=u.createElement(i);k.async=true;k.src='${UG_EMBED_SRC}';f.parentNode.insertBefore(k,f);if(g[d])return;var ug=g[d]={q:[]};ug.c=function(n){return function(){ug.q.push([n,arguments])};};var m=['previewGuide','finishPreview','track','identify','hideChecklist','launchChecklist'];for(var j=0;j<m.length;j+=1){ug[m[j]]=ug.c(m[j]);}})(window,document,'script','userGuiding','userGuidingLayer','YOJ104543AKXID');`
      document.body.appendChild(ugStub)
    }

    const existingChatbaseScript = document.getElementById(CHATBASE_EMBED_ID)
    const chatbaseLoaderId = 'support-chatbase-loader'
    const existingChatbaseLoader = document.getElementById(chatbaseLoaderId)
    if (!existingChatbaseScript && !existingChatbaseLoader && typeof window !== 'undefined') {
      const chatbaseLoader = document.createElement('script')
      chatbaseLoader.id = chatbaseLoaderId
      chatbaseLoader.text = `(function(){if(!window.chatbase||window.chatbase("getState")!=="initialized"){window.chatbase=(...arguments)=>{if(!window.chatbase.q){window.chatbase.q=[]}window.chatbase.q.push(arguments)};window.chatbase=new Proxy(window.chatbase,{get(target,prop){if(prop==="q"){return target.q}return(...args)=>target(prop,...args)}})}const onLoad=function(){const script=document.createElement("script");script.src="https://www.chatbase.co/embed.min.js";script.id="${CHATBASE_EMBED_ID}";script.domain="www.chatbase.co";document.body.appendChild(script)};if(document.readyState==="complete"){onLoad()}else{window.addEventListener("load",onLoad)}})();`
      document.body.appendChild(chatbaseLoader)
    }

    return () => {
      try {
        const embed = document.getElementById(CHATBASE_EMBED_ID)
        if (embed && embed.parentNode) embed.parentNode.removeChild(embed)
        const loader = document.getElementById(chatbaseLoaderId)
        if (loader && loader.parentNode) loader.parentNode.removeChild(loader)
        if (window.chatbase) {
          try { delete window.chatbase } catch {}
          window.chatbase = undefined
        }
      } catch {}

      try {
        const ugEmbed = document.querySelector(`script[src="${UG_EMBED_SRC}"]`)
        if (ugEmbed && ugEmbed.parentNode) ugEmbed.parentNode.removeChild(ugEmbed)
        const ugStub = document.querySelector('script[data-ug-stub="true"]')
        if (ugStub && ugStub.parentNode) ugStub.parentNode.removeChild(ugStub)
        if (window.userGuiding) { try { delete window.userGuiding } catch {}; window.userGuiding = undefined }
        if (window.userGuidingLayer) { try { delete window.userGuidingLayer } catch {}; window.userGuidingLayer = undefined }
      } catch {}
    }
  }, [])

  return null
}

export default SupportScripts